/**
 * R24 · Kalles-Menue-Schublade: Anreicherung (Symbole, Socials, gueltige Kollektionen)
 *
 * Ausgelagert aus snippets/r24-menu-drawer.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function(){
  /* Add-on: Vorteils-Streifen oben in den Mobile-Drawer einsetzen, sobald der
     (lazy geladene) Menü-Inhalt erscheint. Idempotent + defensiv. */
  function enhance(){
    var d=document.getElementById('t4s-menu-drawer'); if(!d) return;
    var menu=d.querySelector('.t4s-mb__menu'); if(!menu) return;
    /* 1) Vorteils-Streifen oben */
    if(!d.querySelector('.r24-mdrawer-trust')){
      var wrap=document.createElement('div');
      wrap.className='r24-mdrawer-trust';
      wrap.innerHTML=
        '<span><i class="las la-shipping-fast" aria-hidden="true"></i> Schneller Versand</span>'+
        '<span><i class="las la-lock" aria-hidden="true"></i> Sichere Bezahlung</span>'+
        '<span><i class="las la-undo-alt" aria-hidden="true"></i> 14 Tage Widerruf</span>';
      menu.parentNode.insertBefore(wrap, menu);
    }
    /* 1b) Möbelserien-Zugang oben in die Drawer-Navigation (theme-scoped) */
    if(menu && !d.querySelector('.r24-mdrawer-serien')){
      var sli=document.createElement('li');
      sli.className='t4s-menu-item t4s-item-level-0 r24-mdrawer-serien';
      sli.innerHTML='<a href="/pages/alle-serien"><i class="las la-th-large" aria-hidden="true"></i> Möbelserien</a>';
      menu.insertBefore(sli, menu.firstChild);
    }
    /* 1c) Küchenplaner-Zugang oben in die Drawer-Navigation (theme-scoped).
       Auf dem Desktop liegt der Link fest in r24-header-2026; das Mobile-Menü
       ist der Kalles-Linklist-Drawer, in dem er sonst fehlt → hier ergänzen. */
    if(menu && !d.querySelector('.r24-mdrawer-planer')){
      var pli=document.createElement('li');
      pli.className='t4s-menu-item t4s-item-level-0 r24-mdrawer-planer';
      pli.innerHTML='<a href="/pages/kuechenplaner"><i class="las la-drafting-compass" aria-hidden="true"></i> Küchenplaner</a>';
      var serien=d.querySelector('.r24-mdrawer-serien');
      if(serien){ serien.insertAdjacentElement('afterend', pli); }
      else { menu.insertBefore(pli, menu.firstChild); }
    }
    /* 2) Warenkorb-Schnellzugriff in den Aktions-Block (live-Zähler aus Header) */
    if(!d.querySelector('.r24-mdrawer-cart')){
      var cnt=''; var cb=document.querySelector('.t4s-site-nav__cart .t4s-count-box, a[href="/cart"] .t4s-count-box, [data-cart-count]');
      if(cb) cnt=(cb.textContent||'').trim();
      var li=document.createElement('li');
      li.className='t4s-menu-item t4s-item-level-0 t4s-menu-item-btns r24-mdrawer-cart';
      li.innerHTML='<a href="/cart"><i class="las la-shopping-bag" aria-hidden="true"></i> Warenkorb'+
        (cnt && cnt!=='0' ? ' <span class="r24-mdrawer-cart__n">'+cnt+'</span>' : '')+'</a>';
      var btns=menu.querySelectorAll('.t4s-menu-item-btns');
      if(btns.length){ btns[btns.length-1].insertAdjacentElement('afterend', li); }
      else { menu.insertBefore(li, menu.firstChild); }
    }
    /* 3b) Tote/leere/Roh-Pfad-Kategorielinks ausblenden (Owner-Wunsch: keine
       falschen/rauen Produktpfade auf dem Handy). Behalten: Aktions-Block, eigene
       R24-Zeilen, Seiten (/pages, /blogs), Konto/Suche, und aufklappbare Eltern MIT
       Untermenü. Ausblenden: href="#"-Blätter, /collections/all, und Kollektionslinks,
       deren Handle nicht in der Allowlist echter, nicht-leerer Kollektionen steht. */
    try {
      var valid = window.__r24ValidCols;
      d.querySelectorAll('.t4s-mb__menu a[href]').forEach(function(a){
        var li = a.closest('.t4s-menu-item'); if(!li) return;
        if(li.classList.contains('t4s-menu-item-btns')) return;
        if((li.className||'').indexOf('r24-mdrawer') > -1) return;
        var h = a.getAttribute('href') || '';
        var hasSub = !!li.querySelector('.t4s-sub-menu');
        var bad = false;
        if((h === '#' || h === '') && !hasSub) { bad = true; }               /* totes Blatt */
        else if(/\/collections\/all(\/|$|\?|#)/.test(h)) { bad = true; }       /* Roh-„all"-Pfad */
        else {
          var m = h.match(/\/collections\/([^\/?#]+)/);
          if(m && valid && valid.size) {
            var hn = decodeURIComponent(m[1]);
            if(!valid.has(hn)) bad = true;                                     /* tote/leere Kollektion */
          }
        }
        if(bad) li.style.display = 'none';
      });
    } catch(e){}
    /* 3) Social-Reihe am Drawer-Ende (aus Theme-Settings) */
    if(!d.querySelector('.r24-mdrawer-social')){
      var s=window.__r24DrawerSocials||'';
      if(s){
        var soc=document.createElement('div'); soc.className='r24-mdrawer-social';
        soc.innerHTML='<span class="r24-mdrawer-social__lbl">Folgen Sie uns</span><div class="r24-mdrawer-social__row">'+s+'</div>';
        (menu.parentNode||d).insertBefore(soc, menu.nextSibling);
      }
    }
  }
  /* Der Drawer existiert beim Inline-Ausführen oben im <body> noch NICHT →
     Observer erst anhängen, sobald #t4s-menu-drawer im DOM ist. */
  function attach(){
    var d=document.getElementById('t4s-menu-drawer'); if(!d) return false;
    if(!d.__r24obs){ try{ d.__r24obs=new MutationObserver(enhance); d.__r24obs.observe(d,{childList:true,subtree:true}); }catch(e){} }
    enhance(); return true;
  }
  if(!attach()){
    document.addEventListener('DOMContentLoaded',attach);
    window.addEventListener('load',attach);
  }
})();
